import { Import } from 'src/dto/Import';
import { baseApiWithCompanyId } from 'src/redux/services/baseApi';

export interface GetImportsResponse {
  documents: Import[];
  total: number;
  filters: {
    app_key: string;
  };
}

export interface GetImportResponse {
  item: Import;
  total: number;
  filters: {
    key: string;
  };
}

interface ModelChangeSuggestions {
  new_rule: Rule | null;
  old_rule: Rule | null;
  performance_change: number;
}

interface GetRuleRaccomendationResponse {
  progress: number;
  model_name: string;
  key: string;
  model_change_suggestions: ModelChangeSuggestions[];
  status: 'IN_PROGRESS' | 'COMPLETED' | 'ERROR';
  total_count: number;
  partial_count: number;
}
export interface Rule {
  type: string;
  operator: string;
  name: string;
  effect: { destination?: string; direction: string; weight?: number };
  conditions: Condition[];
}

interface Condition {
  comparator: string;
  product: string;
  value: boolean | string | number | string[] | number[];
  target: string;
}

const importsApi = baseApiWithCompanyId.injectEndpoints({
  endpoints: (builder) => ({
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    getImportList: builder.query<GetImportsResponse, string>({
      query: () => ({
        url: 'v2/imports',
      }),
      providesTags: ['Imports'],
    }),
    upload: builder.mutation<any, any>({
      query({ csvfile, appkey }) {
        const bodyFormData = new FormData();
        bodyFormData.append('file', csvfile[0]);
        return {
          url: `v2/imports/uploadcsv?app_key=${appkey}`,
          method: 'POST',

          body: bodyFormData,
          formData: true,
        };
      },
    }),
    getImportDocument: builder.query<GetImportResponse, string>({
      query: (documentId: string) => ({
        url: `v2/imports/${documentId}`,
      }),
      providesTags: ['Imports'],
    }),

    startImport: builder.mutation<any, any>({
      query(documentId) {
        return {
          url: `v2/imports/${documentId}/start`,
          method: 'POST',
        };
      },
    }),
    startFeatureAnalysesImport: builder.mutation<any, any>({
      query(documentId) {
        return {
          url: `v1/feature-analyses/${documentId}/start`,
          method: 'POST',
        };
      },
    }),
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    getFeatureAnalysis: builder.query<any, { id: string }>({
      query: ({ id }) => ({
        url: `v1/feature-analyses/${id}`,
      }),
    }),
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    getFeatureAnalysisResult: builder.query<any, { id: string }>({
      query: ({ id }) => ({
        url: `v1/feature-analyses/${id}/result`,
      }),
    }),
    uploadFeatureAnalyses: builder.mutation<any, any>({
      query({ csvfile, appkey }) {
        const bodyFormData = new FormData();
        bodyFormData.append('file', csvfile[0]);
        return {
          url: `v1/feature-analyses/uploadcsv?app_key=${appkey}`,
          method: 'POST',

          body: bodyFormData,
          formData: true,
        };
      },
    }),
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    getFeatureAnalysesList: builder.query<GetImportsResponse, string>({
      query: () => ({
        url: '/v1/feature-analyses',
      }),
      providesTags: ['Imports'],
    }),
    getRuleRaccomendation: builder.query<GetRuleRaccomendationResponse, { key: string; app_key: string }>({
      query: ({ key, app_key }) => ({
        url: `/v1/rule-recommendation/progress`,
        params: {
          key: key,
          app_key: app_key,
        },
      }),
    }),
  }),
});

export const {
  useGetImportListQuery,
  useUploadMutation,
  useGetRuleRaccomendationQuery,
  useGetImportDocumentQuery,
  useStartImportMutation,
  useGetFeatureAnalysisResultQuery,
  useGetFeatureAnalysisQuery,
  useUploadFeatureAnalysesMutation,
  useGetFeatureAnalysesListQuery,
  useStartFeatureAnalysesImportMutation,
} = importsApi;
